import { useQuery } from '@tanstack/react-query';
import { ticketsService } from '../../../api/services/tickets';
import type { GetUserTicketsParams } from '../../../api/services/tickets';

export const useGetUserTickets = (params?: GetUserTicketsParams) => {
  return useQuery({
    queryKey: ['user-tickets', params],
    queryFn: () => ticketsService.listTickets(params),
  });
};

export const useGetUserTicketEvents = (includeRevoked?: boolean) => {
  return useQuery({
    queryKey: ['user-tickets-events', { includeRevoked: !!includeRevoked }],
    queryFn: () => ticketsService.listUserTicketEvents(includeRevoked),
    staleTime: 5 * 60 * 1000,
  });
};

export const useGetUserTicket = (ticketId?: string) => {
  return useQuery({
    queryKey: ['user-ticket', ticketId],
    queryFn: () => ticketsService.getTicketById(ticketId as string),
    enabled: !!ticketId,
  });
};

export const useGetTicketImage = (ticketId?: string, enabled?: boolean) => {
  return useQuery({
    queryKey: ['ticket-image', ticketId],
    queryFn: () => ticketsService.getTicketImage(ticketId as string),
    enabled: !!ticketId && (enabled ?? true),
  });
};

export const useGetTicketQrCode = (ticketId?: string, enabled?: boolean) => {
  return useQuery({
    queryKey: ['ticket-qrcode', ticketId],
    queryFn: () => ticketsService.getTicketQrCode(ticketId as string),
    enabled: !!ticketId && (enabled ?? true),
  });
};
